<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
  <circle cx="12" cy="12.996" r="11.5" stroke="#000"/>
  <path stroke="#000" d="M17 15.33l-5-5-5 5"/>
</svg>
